(function () {
  'use strict';

  var teaseShownFallback = false;

  function initHorizontal(slider) {
    var viewport = slider.querySelector('.arn-flavour-slider__viewport');
    var track = slider.querySelector('.arn-flavour-slider__track');
    var items = Array.prototype.slice.call(slider.querySelectorAll('.arn-flavour-slider__item'));
    var scrollbar = slider.querySelector('[data-arn-scrollbar]');

    if (!viewport || !track || items.length === 0) return;

    /*
      Important:
      We no longer move the desktop flavour row with transform.
      Transform was the reason the final item could end up half cut off.
      This uses native scrollLeft instead, which is more reliable.
    */
    track.style.transform = 'none';
    track.style.transition = 'none';
    track.style.paddingLeft = '0px';
    track.style.paddingRight = '0px';

    viewport.style.overflowX = 'auto';
    viewport.style.overflowY = 'hidden';
    viewport.style.scrollBehavior = 'auto';

    items.forEach(function (item) {
      if (item.classList.contains('is-current')) {
        item.classList.add('is-focused');
      }
    });

    function getMaxScroll() {
      return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    }

    function setScrollbarFromScroll() {
      if (!scrollbar) return;

      var maxScroll = getMaxScroll();
      var pct = maxScroll > 0 ? (viewport.scrollLeft / maxScroll) * 100 : 0;

      scrollbar.value = Math.max(0, Math.min(100, pct));
    }

    function scrollToPct(pct, smooth) {
      var maxScroll = getMaxScroll();
      var clampedPct = Math.max(0, Math.min(100, pct));
      var nextLeft = (clampedPct / 100) * maxScroll;

      if (smooth && typeof viewport.scrollTo === 'function') {
        viewport.scrollTo({
          left: nextLeft,
          behavior: 'smooth'
        });
      } else {
        viewport.scrollLeft = nextLeft;
      }

      setTimeout(setScrollbarFromScroll, smooth ? 260 : 0);
    }

    function hideOrShowScrollbar() {
      if (!scrollbar || !scrollbar.parentElement) return;

      if (getMaxScroll() <= 2) {
        scrollbar.parentElement.style.display = 'none';
      } else {
        scrollbar.parentElement.style.display = '';
      }
    }

    function getCurrentItem() {
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-current')) return items[i];
      }

      return null;
    }

    function scrollCurrentIntoView() {
      var current = getCurrentItem();
      if (!current) return;

      var maxScroll = getMaxScroll();
      if (maxScroll <= 0) {
        viewport.scrollLeft = 0;
        setScrollbarFromScroll();
        return;
      }

      var itemLeft = current.offsetLeft;
      var itemWidth = current.offsetWidth || current.getBoundingClientRect().width || 0;
      var itemRight = itemLeft + itemWidth;
      var viewLeft = viewport.scrollLeft;
      var viewRight = viewLeft + viewport.clientWidth;

      var nextLeft = viewLeft;

      if (itemRight > viewRight) {
        nextLeft = itemRight - viewport.clientWidth;
      }

      if (itemLeft < viewLeft) {
        nextLeft = itemLeft;
      }

      /*
        If the current item is the final visible flavour, give it a little
        breathing room so the circle and label are not tight against the edge.
      */
      var currentIndex = items.indexOf(current);
      if (currentIndex === items.length - 1) {
        nextLeft = maxScroll;
      }

      viewport.scrollLeft = Math.max(0, Math.min(maxScroll, nextLeft));
      setScrollbarFromScroll();
    }

    if (scrollbar) {
      scrollbar.addEventListener('input', function () {
        scrollToPct(parseFloat(scrollbar.value), false);
      });

      scrollbar.addEventListener('change', function () {
        scrollToPct(parseFloat(scrollbar.value), true);
      });
    }

    viewport.addEventListener('scroll', function () {
      window.requestAnimationFrame(setScrollbarFromScroll);
    }, { passive: true });

    function refresh() {
      hideOrShowScrollbar();
      scrollCurrentIntoView();
      setScrollbarFromScroll();
    }

    refresh();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 120);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refresh).catch(function () {});
    }

    window.addEventListener('load', function () {
      refresh();
      setTimeout(refresh, 250);
      setTimeout(refresh, 750);
    });
  }

  function initVertical(slider) {
    var viewport = slider.querySelector('.arn-flavour-slider__viewport');
    var items = Array.prototype.slice.call(slider.querySelectorAll('.arn-flavour-slider__item'));

    if (!viewport || items.length === 0) return;

    var rafId = null;

    function updateEnd() {
      var atEnd = viewport.scrollTop + viewport.clientHeight >= viewport.scrollHeight - 4;
      slider.classList.toggle('is-at-end', atEnd);
    }

    function prefersReducedMotion() {
      return window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function teaseAlreadyShown() {
      try {
        return sessionStorage.getItem('arnFlavourTeaseSeen') === '1';
      } catch (e) {
        return teaseShownFallback;
      }
    }

    function markTeaseShown() {
      teaseShownFallback = true;
      try {
        sessionStorage.setItem('arnFlavourTeaseSeen', '1');
      } catch (e) {}
    }

    /*
      One-time scroll tease.
      Reveals that the list scrolls by easing down a couple of rows and back.
      - Skipped entirely for prefers-reduced-motion (vestibular safety).
      - Never touches focus / DOM / aria, so it is silent to screen readers.
      - Single motion under ~1.5s, so WCAG 2.2.2 needs no pause control.
      - Fires once per session, not per page, so it does not replay on every
        flavour hop across identical PDPs.
      - Cancels the instant the user touches or scrolls.
    */
    function runScrollTease() {
      if (prefersReducedMotion()) return;
      if (teaseAlreadyShown()) return;
      if (slider.offsetParent === null) return;

      var overflow = viewport.scrollHeight - viewport.clientHeight;
      if (overflow <= 24) return;

      markTeaseShown();

      var restTop = viewport.scrollTop;
      var travel = Math.min(overflow, viewport.clientHeight * 1.1);
      var peekTop = Math.min(overflow, restTop + travel);

      var prevBehavior = viewport.style.scrollBehavior;
      viewport.style.scrollBehavior = 'auto';

      var cancelled = false;

      function cleanup() {
        viewport.style.scrollBehavior = prevBehavior;
        viewport.removeEventListener('touchstart', cancel);
        viewport.removeEventListener('wheel', cancel);
        viewport.removeEventListener('pointerdown', cancel);
        viewport.removeEventListener('keydown', cancel);
      }

      function cancel() {
        if (cancelled) return;
        cancelled = true;
        cleanup();
      }

      viewport.addEventListener('touchstart', cancel, { passive: true });
      viewport.addEventListener('wheel', cancel, { passive: true });
      viewport.addEventListener('pointerdown', cancel, { passive: true });
      viewport.addEventListener('keydown', cancel);

      var down = 700;
      var hold = 120;
      var back = 600;

      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      var startTs = null;

      function frame(ts) {
        if (cancelled) return;
        if (startTs === null) startTs = ts;

        var elapsed = ts - startTs;

        if (elapsed <= down) {
          viewport.scrollTop = restTop + (peekTop - restTop) * easeOutCubic(elapsed / down);
          window.requestAnimationFrame(frame);
        } else if (elapsed <= down + hold) {
          viewport.scrollTop = peekTop;
          window.requestAnimationFrame(frame);
        } else if (elapsed <= down + hold + back) {
          var p = easeInOutCubic((elapsed - down - hold) / back);
          viewport.scrollTop = peekTop + (restTop - peekTop) * p;
          window.requestAnimationFrame(frame);
        } else {
          viewport.scrollTop = restTop;
          updateFocus();
          updateEnd();
          cleanup();
        }
      }

      window.requestAnimationFrame(frame);
    }

    function updateFocus() {
      var vpRect = viewport.getBoundingClientRect();
      var anchor = vpRect.top + vpRect.height / 2;
      var closest = null;
      var closestDist = Infinity;

      items.forEach(function (item) {
        var r = item.getBoundingClientRect();
        var c = r.top + r.height / 2;
        var d = Math.abs(c - anchor);

        if (d < closestDist) {
          closestDist = d;
          closest = item;
        }
      });

      if (!closest) return;

      items.forEach(function (item) {
        if (item === closest) item.classList.add('is-focused');
        else item.classList.remove('is-focused');
      });
    }

    function onScroll() {
      if (rafId) return;

      rafId = window.requestAnimationFrame(function () {
        updateFocus();
        updateEnd();
        rafId = null;
      });
    }

    function scrollCurrentIntoView() {
      var current = slider.querySelector('.arn-flavour-slider__item.is-current');

      if (!current || slider.offsetParent === null) return;

      var vpRect = viewport.getBoundingClientRect();
      var itemRect = current.getBoundingClientRect();
      var topOffset = itemRect.top - vpRect.top + viewport.scrollTop;

      viewport.scrollTop = topOffset - vpRect.height / 2 + itemRect.height / 2;
    }

    viewport.addEventListener('scroll', onScroll, { passive: true });

    var resizeTimer;

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(function () {
        if (slider.offsetParent !== null) {
          scrollCurrentIntoView();
          updateFocus();
          updateEnd();
        }
      }, 120);
    });

    if (typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            scrollCurrentIntoView();
            updateFocus();
            updateEnd();
          }
        });
      }, { threshold: 0.1 });

      io.observe(slider);
    }

    scrollCurrentIntoView();
    requestAnimationFrame(function () {
      updateFocus();
      updateEnd();
    });

    setTimeout(function () {
      if (slider.offsetParent !== null) runScrollTease();
    }, 1100);
  }

  function initSlider(slider) {
    if (slider.dataset.arnSliderInitialized === 'true') return;

    slider.dataset.arnSliderInitialized = 'true';

    var orientation = slider.dataset.orientation || 'horizontal';

    if (orientation === 'horizontal') {
      initHorizontal(slider);
    } else {
      initVertical(slider);
    }
  }

  function init() {
    document.querySelectorAll('.arn-flavour-slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();